export class NavigationItem {
    route: string;
    label: string;
}
